/*
 * @FilePath     : /es-package/packages/es-mpx-storage/lib/alias.js
 * @Author       : LiYang
 * @Date         : 2022-02-08 15:08:45
 * @LastEditTime : 2022-02-08 17:19:33
 * @LastEditors  : Please set LastEditors
 * @Description  : 原型
 */

export default {
  clear() {
    this.storage.clear()
  },
  
  get(key) {
    const value = this.storage.getItem(key);
    try {
      return JSON.parse(value)
    } catch (error) {
      return value
    } 
  },

  set(name, value) {
    this.storage.setItem(
      name,
      (typeof value !== 'string' ? JSON.stringify(value) : value),
    )
  },

  remove(key) {
    this.storage.removeItem(key)
  },

  key(index) {
    return this.storage.key(index)
  },

  get keys() {
    const len = this.lenght;
    const res = [];

    for (let index = 0; index < len; index++) {
      res.push(this.storage.key(index));
    }
    return res;
  },

  get length() {
    return this.storage.length;
  }

}